module.exports = __webpack_public_path__ + "img/cappucino.9f296b6f.jpg";